import { createFileRoute } from "@tanstack/react-router";
import { ThemingDesignSystem } from "@/pages/design-system/ThemingDesignSystem";

export const Route = createFileRoute("/demo/design-system/theming/")({
  component: ThemingDesignSystem,
});
